import { Map } from 'immutable'
import isString from 'lodash-es/isString'
import { useEffect } from 'react'

import { AssetTrackingData } from '@/feature/telemetry'

import { useTelemetryStore } from '../store/telemetry'

const sentinel = Symbol('sentinel')

export function useAssetTelemetry(): Map<string, AssetTrackingData>
export function useAssetTelemetry(assetId: string | null | undefined): AssetTrackingData | undefined
export function useAssetTelemetry(
  assetId: unknown = sentinel,
): Map<string, AssetTrackingData> | AssetTrackingData | undefined {
  const incrementUsage = useTelemetryStore((state) => state.incrementActiveListeners)
  const decrementUsage = useTelemetryStore((state) => state.decrementActiveListeners)

  useEffect(() => {
    incrementUsage()
    return () => {
      decrementUsage()
    }
  }, [])

  return useTelemetryStore((state) => {
    if (assetId === sentinel) {
      return state.tracking
    } else if (isString(assetId)) {
      return state.tracking.get(assetId)
    }
  })
}
